<template>
  <v-hover>
    <template v-slot:default="{ hover }">
      <v-card class="panel bg-transparent my-8-px" flat elevation="0">
        <v-expansion-panels v-if="content.length > 0">
          <v-expansion-panel v-for="(item, i) in content" :key="i">
            <v-expansion-panel-header>
              {{ item.title }}
            </v-expansion-panel-header>
            <v-expansion-panel-content v-html="item.text">
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <div
          v-else-if="modifyMode.show && editedAuth"
          class="grey--text text-center py-10-px grey lighten-2"
        >
          #{{ data.ctxId }} 無英文版 手風琴內文
        </div>
        <v-fade-transition
          v-if="modifyMode.show && editedAuth && createMode === -1"
        >
          <v-overlay v-if="hover" absolute :color="hoverColor">
            <v-btn plain @click.stop="setCreateMode({ obj: data, mode: 0 })">
              <v-icon left class="fz-16-px">mdi-square-edit-outline</v-icon>
              EDIT
            </v-btn>
          </v-overlay>
        </v-fade-transition>
      </v-card>
    </template>
  </v-hover>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'Panel',

  props: ['data', 'hoverColor', 'modifyMode', 'editedAuth'],

  data() {
    return {}
  },

  computed: {
    ...mapState('document', ['createMode']),
    content() {
      return this.data.content
    }
  },

  methods: {
    ...mapActions('document', ['setCreateMode'])
  }
}
</script>

<style lang="scss" scoped>
.v-expansion-panel-content {
  display: block;
  padding: 6px 24px;
}
</style>
